import type { GetServerSideProps } from 'next';
import { createContext, useState } from 'react';

import { Layout } from 'components/layout';

import NewsletterRibbonForm from 'components/NewsletterRibbon/NewsletterRibbonForm';
import Toast from 'components/pages/newsletters/Toast';

export type NewslettersContextType = {
  showOverlay: boolean;
  setShowOverlay: (showOverlay: boolean) => void;
  closeOverlay: () => void;
  newsletterName: string;
  setNewsletterName: (newsletterName: string) => void;
  newsletterFrequencyOption: string;
  setNewsletterFrequencyOption: (newsletterFrequencyOption: string) => void;
  subscribed: boolean;
  setSubscribed: (subscribed: boolean) => void;
};

export const NewslettersContext = createContext<NewslettersContextType | null>(
  null
);

export default function NewslettersPage(): React.ReactNode {
  const [showOverlay, setShowOverlay] = useState(false);
  const [newsletterName, setNewsletterName] = useState('');
  const [newsletterFrequencyOption, setNewsletterFrequencyOption] =
    useState('');
  const [subscribed, setSubscribed] = useState(false);

  const closeOverlay = () => setShowOverlay(false);

  return (
    <NewslettersContext
      value={{
        showOverlay,
        setShowOverlay,
        closeOverlay,
        newsletterName,
        setNewsletterName,
        newsletterFrequencyOption,
        setNewsletterFrequencyOption,
        subscribed,
        setSubscribed
      }}
    >
      <Layout addMinHeight={false} isDarkMode>
        <NewsletterRibbonForm />
      </Layout>
      <Toast />
    </NewslettersContext>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.setHeader('Cache-Control', 'no-transform, public, max-age=180');

  return {
    props: {}
  };
};
